/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum BloodProductsViewFragmentAliases {
  CHECKBOX_ALIQUOTED = 'checkbox-aliquoted',
  CHECKBOX_FILTERED = 'checkbox-filtered',
  CHECKBOX_IRRADIATED = 'checkbox-irradiated',
  CHECKBOX_PHENOTYPED = 'checkbox-phenotyped',
  CHECKBOX_WASHED = 'checkbox-washed',
  CONTEXTUAL_BAR_BLOOD_PRODUCTS = 'contextual-bar-blood-products',
  FIELD_ADMINISTRATION_ITEM_1 = 'field-administration-item-1',
  FIELD_ADMINISTRATION_ITEM_2 = 'field-administration-item-2',
  FIELD_ADMINISTRATION_ITEM_3 = 'field-administration-item-3',
  FIELD_ADMINISTRATION_ITEM_4 = 'field-administration-item-4',
  FIELD_ADMINISTRATION_ITEM_5 = 'field-administration-item-5',
  FIELD_ALIQUOTED = 'field-aliquoted',
  FIELD_BLOOD_PRODUCTS = 'field-blood-products',
  FIELD_BLOOD_PRODUCTS_ROUTE = 'field-blood-products-route',
  FIELD_DIAGNOSIS = 'field-diagnosis',
  FIELD_DILUENT_DOSE_ITEM_1 = 'field-diluent-dose-item-1',
  FIELD_DILUENT_DOSE_ITEM_2 = 'field-diluent-dose-item-2',
  FIELD_DILUENT_DOSE_ITEM_3 = 'field-diluent-dose-item-3',
  FIELD_DILUENT_DOSE_ITEM_4 = 'field-diluent-dose-item-4',
  FIELD_DILUENT_DOSE_ITEM_5 = 'field-diluent-dose-item-5',
  FIELD_DILUENT_ITEM_1 = 'field-diluent-item-1',
  FIELD_DILUENT_ITEM_2 = 'field-diluent-item-2',
  FIELD_DILUENT_ITEM_3 = 'field-diluent-item-3',
  FIELD_DILUENT_ITEM_4 = 'field-diluent-item-4',
  FIELD_DILUENT_ITEM_5 = 'field-diluent-item-5',
  FIELD_DILUENT_UNIT_OF_MEASUREMENT_ITEM_1 = 'field-diluent-unit-of-measurement-item-1',
  FIELD_DILUENT_UNIT_OF_MEASUREMENT_ITEM_2 = 'field-diluent-unit-of-measurement-item-2',
  FIELD_DILUENT_UNIT_OF_MEASUREMENT_ITEM_3 = 'field-diluent-unit-of-measurement-item-3',
  FIELD_DILUENT_UNIT_OF_MEASUREMENT_ITEM_4 = 'field-diluent-unit-of-measurement-item-4',
  FIELD_DILUENT_UNIT_OF_MEASUREMENT_ITEM_5 = 'field-diluent-unit-of-measurement-item-5',
  FIELD_DOSE_ITEM_1 = 'field-dose-item-1',
  FIELD_DOSE_ITEM_2 = 'field-dose-item-2',
  FIELD_DOSE_ITEM_3 = 'field-dose-item-3',
  FIELD_DOSE_ITEM_4 = 'field-dose-item-4',
  FIELD_DOSE_ITEM_5 = 'field-dose-item-5',
  FIELD_END_DATE_TIME = 'field-end-date-time',
  FIELD_FILTERED = 'field-filtered',
  FIELD_HEMOTERAPY = 'field-hemoterapy',
  FIELD_HOURS = 'field-hours',
  FIELD_HOURS_ITEM_1 = 'field-hours-item-1',
  FIELD_HOURS_ITEM_2 = 'field-hours-item-2',
  FIELD_HOURS_ITEM_3 = 'field-hours-item-3',
  FIELD_HOURS_ITEM_4 = 'field-hours-item-4',
  FIELD_HOURS_ITEM_5 = 'field-hours-item-5',
  FIELD_INFUSION_RATE = 'field-infusion-rate',
  FIELD_INTERVAL = 'field-interval',
  FIELD_INTERVAL_ITEM_1 = 'field-interval-item-1',
  FIELD_INTERVAL_ITEM_2 = 'field-interval-item-2',
  FIELD_INTERVAL_ITEM_3 = 'field-interval-item-3',
  FIELD_INTERVAL_ITEM_4 = 'field-interval-item-4',
  FIELD_INTERVAL_ITEM_5 = 'field-interval-item-5',
  FIELD_IRRADIATED = 'field-irradiated',
  FIELD_ITEM_1 = 'field-item-1',
  FIELD_ITEM_2 = 'field-item-2',
  FIELD_ITEM_3 = 'field-item-3',
  FIELD_ITEM_4 = 'field-item-4',
  FIELD_ITEM_5 = 'field-item-5',
  FIELD_JUSTIFICATION = 'field-justification',
  FIELD_LAST_TRANSFUSION_DATE = 'field-last-transfusion-date',
  FIELD_NUMBER_OF_TRANSFUSIONS = 'field-number-of-transfusions',
  FIELD_OBSERVATION = 'field-observation',
  FIELD_OBSERVATION_ITEM_1 = 'field-observation-item-1',
  FIELD_OBSERVATION_ITEM_2 = 'field-observation-item-2',
  FIELD_OBSERVATION_ITEM_3 = 'field-observation-item-3',
  FIELD_OBSERVATION_ITEM_4 = 'field-observation-item-4',
  FIELD_OBSERVATION_ITEM_5 = 'field-observation-item-5',
  FIELD_PATIENT_TYPE = 'field-.patient-type',
  FIELD_PHENOTYPED = 'field-phenotyped',
  FIELD_PRESCRIBER_DATE = 'field-prescriber-date',
  FIELD_PRESCRIBER_NAME = 'field-prescriber-name',
  FIELD_PREVIOUS_TRANSFUSION_REACTION = 'field-previous-transfusion-reaction',
  FIELD_PREVIOUS_TRANSFUSION_REACTION_2 = 'field-previous-transfusion-reaction-2',
  FIELD_PREVIOUS_TRANSFUSIONS = 'field-previous-transfusions',
  FIELD_PROCEDURE = 'field-procedure',
  FIELD_PROCEDURE_INTERVAL = 'field-procedure-interval',
  FIELD_PROCEDURE_REFERRAL = 'field-procedure-referral',
  FIELD_QUANTITY_UNITS = 'field-quantity-units',
  FIELD_REACTION_BLOOD_PRODUCT = 'field-reaction-blood-product',
  FIELD_REACTION_BLOOD_PRODUCT_2 = 'field-reaction-blood-product-2',
  FIELD_REACTION_SYMPTOMS = 'field-reaction-symptoms',
  FIELD_REACTION_SYMPTOMS_2 = 'field-reaction-symptoms-2',
  FIELD_REFERRAL = 'field-referral',
  FIELD_ROUTE_ITEM_1 = 'field-route-item-1',
  FIELD_ROUTE_ITEM_2 = 'field-route-item-2',
  FIELD_ROUTE_ITEM_3 = 'field-route-item-3',
  FIELD_ROUTE_ITEM_4 = 'field-route-item-4',
  FIELD_ROUTE_ITEM_5 = 'field-route-item-5',
  FIELD_SCHEDULED_DATE_TIME = 'field-scheduled-date-time',
  FIELD_START_ITEM_1 = 'field-start-item-1',
  FIELD_START_ITEM_2 = 'field-start-item-2',
  FIELD_START_ITEM_3 = 'field-start-item-3',
  FIELD_START_ITEM_4 = 'field-start-item-4',
  FIELD_START_ITEM_5 = 'field-start-item-5',
  FIELD_TOTAL_INFUSION_DURATION = 'field-total-infusion-duration',
  FIELD_TRANSFUSION_MODALITY = 'field-transfusion-modality',
  FIELD_TYPE = 'field-type',
  FIELD_UNIT_INFUSION_DURATION = 'field-unit-infusion-duration',
  FIELD_UNIT_OF_MEASUREMENT = 'field-unit-of-measurement',
  FIELD_UNIT_OF_MEASUREMENT_ITEM_1 = 'field-unit-of-measurement-item-1',
  FIELD_UNIT_OF_MEASUREMENT_ITEM_2 = 'field-unit-of-measurement-item-2',
  FIELD_UNIT_OF_MEASUREMENT_ITEM_3 = 'field-unit-of-measurement-item-3',
  FIELD_UNIT_OF_MEASUREMENT_ITEM_4 = 'field-unit-of-measurement-item-4',
  FIELD_UNIT_OF_MEASUREMENT_ITEM_5 = 'field-unit-of-measurement-item-5',
  FIELD_VOLUME_ML = 'field-volume-ml',
  FIELD_VOLUME_TO_BE_REMOVED = 'field-volume-to-be-removed',
  FIELD_WASHED = 'field-washed',
  FIELDSET_ITEM_2 = 'fieldset-item-2',
  FIELDSET_ITEM_3 = 'fieldset-item-3',
  FIELDSET_ITEM_4 = 'fieldset-item-4',
  FIELDSET_ITEM_5 = 'fieldset-item-5',
  FORM_ADDITIONAL_INFORMATION = 'form-additional-information',
  FORM_BLOOD_PRODUCTS = 'form-blood-products',
  FORM_PATIENT_INFORMATION = 'form-patient-information',
  FORM_PERIOD_OF_VALIDITY = 'form-period-of-validity',
  FORM_PROCEDURE = 'form-procedure',
  FORM_TRANSFUSION_SUPPORT_MEDICINES = 'form-transfusion-support-medicines',
  FRAGMENT_REFERENCE_BAR_HEADER = 'fragment-reference-bar-header',
  INPUT_END_DATE_TIME = 'input-end-date-time',
  INPUT_SCHEDULED_DATE_TIME = 'input-scheduled-date-time',
  LAYOUT_BLOOD_PRODUCTS = 'layout-blood-products',
  LOADER = 'loader',
  PANEL_BLOOD_PRODUCTS = 'panel-blood-products',
  PANEL_CONTENT = 'panel-content',
  PANEL_LOADER = 'panel-loader',
  PANEL_PROCEDURE = 'panel-procedure',
  SECTION_ADDITIONAL_INFORMATION = 'section-additional-information',
  SECTION_BLOOD_PRODUCTS = 'section-blood-products',
  SECTION_PATIENT_INFORMATION = 'section-patient-information',
  SECTION_PERIOD_OF_VALIDITY = 'section-period-of-validity',
  SECTION_TRANSFUSION_SUPPORT_MEDICINES = 'section-transfusion-support-medicines',
  SUPPRESS_HEADING_MARGIN_ADDITIONAL_INFORMATION = 'suppress-heading-margin-additional-information',
  SUPPRESS_HEADING_MARGIN_BLOOD_PRODUCTS = 'suppress-heading-margin-blood-products',
  SUPPRESS_HEADING_MARGIN_PATIENT_INFORMATION = 'suppress-heading-margin-patient-information',
  SUPPRESS_PERIOD_OF_VALIDITY = 'suppress-period-of-validity',
  SUPPRESS_TRANSFUSION_SUPPORT_MEDICINES = 'suppress-transfusion-support-medicines',
  TEXT_ADMINISTRATION_ITEM_1 = 'text-administration-item-1',
  TEXT_ADMINISTRATION_ITEM_2 = 'text-administration-item-2',
  TEXT_ADMINISTRATION_ITEM_3 = 'text-administration-item-3',
  TEXT_ADMINISTRATION_ITEM_4 = 'text-administration-item-4',
  TEXT_ADMINISTRATION_ITEM_5 = 'text-administration-item-5',
  TEXT_BLOOD_PRODUCTS = 'text-blood-products',
  TEXT_BLOOD_PRODUCTS_ROUTE = 'text-blood-products-route',
  TEXT_DIAGNOSIS = 'text-diagnosis',
  TEXT_DILUENT_DOSE_ITEM_1 = 'text-diluent-dose-item-1',
  TEXT_DILUENT_DOSE_ITEM_2 = 'text-diluent-dose-item-2',
  TEXT_DILUENT_DOSE_ITEM_3 = 'text-diluent-dose-item-3',
  TEXT_DILUENT_DOSE_ITEM_4 = 'text-diluent-dose-item-4',
  TEXT_DILUENT_DOSE_ITEM_5 = 'text-diluent-dose-item-5',
  TEXT_DILUENT_ITEM_1 = 'text-diluent-item-1',
  TEXT_DILUENT_ITEM_2 = 'text-diluent-item-2',
  TEXT_DILUENT_ITEM_3 = 'text-diluent-item-3',
  TEXT_DILUENT_ITEM_4 = 'text-diluent-item-4',
  TEXT_DILUENT_ITEM_5 = 'text-diluent-item-5',
  TEXT_DILUENT_UNIT_OF_MEASUREMENT_ITEM_1 = 'text-diluent-unit-of-measurement-item-1',
  TEXT_DILUENT_UNIT_OF_MEASUREMENT_ITEM_2 = 'text-diluent-unit-of-measurement-item-2',
  TEXT_DILUENT_UNIT_OF_MEASUREMENT_ITEM_3 = 'text-diluent-unit-of-measurement-item-3',
  TEXT_DILUENT_UNIT_OF_MEASUREMENT_ITEM_4 = 'text-diluent-unit-of-measurement-item-4',
  TEXT_DILUENT_UNIT_OF_MEASUREMENT_ITEM_5 = 'text-diluent-unit-of-measurement-item-5',
  TEXT_DOSE_ITEM_1 = 'text-dose-item-1',
  TEXT_DOSE_ITEM_2 = 'text-dose-item-2',
  TEXT_DOSE_ITEM_3 = 'text-dose-item-3',
  TEXT_DOSE_ITEM_4 = 'text-dose-item-4',
  TEXT_DOSE_ITEM_5 = 'text-dose-item-5',
  TEXT_HEMOTERAPY = 'text-hemoterapy',
  TEXT_HOURS = 'text-hours',
  TEXT_HOURS_ITEM_1 = 'text-hours-item-1',
  TEXT_HOURS_ITEM_2 = 'text-hours-item-2',
  TEXT_HOURS_ITEM_3 = 'text-hours-item-3',
  TEXT_HOURS_ITEM_4 = 'text-hours-item-4',
  TEXT_HOURS_ITEM_5 = 'text-hours-item-5',
  TEXT_INFUSION_RATE = 'text-infusion-rate',
  TEXT_INTERVAL = 'text-interval',
  TEXT_INTERVAL_ITEM_1 = 'text-interval-item-1',
  TEXT_INTERVAL_ITEM_2 = 'text-interval-item-2',
  TEXT_INTERVAL_ITEM_3 = 'text-interval-item-3',
  TEXT_INTERVAL_ITEM_4 = 'text-interval-item-4',
  TEXT_INTERVAL_ITEM_5 = 'text-interval-item-5',
  TEXT_ITEM_1 = 'text-item-1',
  TEXT_ITEM_2 = 'text-item-2',
  TEXT_ITEM_3 = 'text-item-3',
  TEXT_ITEM_4 = 'text-item-4',
  TEXT_ITEM_5 = 'text-item-5',
  TEXT_JUSTIFICATION = 'text-justification',
  TEXT_LAST_TRANSFUSION_DATE = 'text-last-transfusion-date',
  TEXT_NUMBER_OF_TRANSFUSIONS = 'text-number-of-transfusions',
  TEXT_OBSERVATION = 'text-observation',
  TEXT_OBSERVATION_ITEM_1 = 'text-observation-item-1',
  TEXT_OBSERVATION_ITEM_2 = 'text-observation-item-2',
  TEXT_OBSERVATION_ITEM_3 = 'text-observation-item-3',
  TEXT_OBSERVATION_ITEM_4 = 'text-observation-item-4',
  TEXT_OBSERVATION_ITEM_5 = 'text-observation-item-5',
  TEXT_PATIENT_TYPE = 'text-.patient-type',
  TEXT_PRESCRIBER_DATE = 'text-prescriber-date',
  TEXT_PRESCRIBER_NAME = 'text-prescriber-name',
  TEXT_PREVIOUS_TRANSFUSION_REACTION = 'text-previous-transfusion-reaction',
  TEXT_PREVIOUS_TRANSFUSION_REACTION_2 = 'text-previous-transfusion-reaction-2',
  TEXT_PREVIOUS_TRANSFUSIONS = 'text-previous-transfusions',
  TEXT_PROCEDURE = 'text-procedure',
  TEXT_PROCEDURE_INTERVAL = 'text-procedure-interval',
  TEXT_PROCEDURE_REFERRAL = 'text-procedure-referral',
  TEXT_QUANTITY_UNITS = 'text-quantity-units',
  TEXT_REACTION_BLOOD_PRODUCT = 'text-reaction-blood-product',
  TEXT_REACTION_BLOOD_PRODUCT_2 = 'text-reaction-blood-product-2',
  TEXT_REACTION_SYMPTOMS = 'text-reaction-symptoms',
  TEXT_REACTION_SYMPTOMS_2 = 'text-reaction-symptoms-2',
  TEXT_REFERRAL = 'text-referral',
  TEXT_ROUTE_ITEM_1 = 'text-route-item-1',
  TEXT_ROUTE_ITEM_2 = 'text-route-item-2',
  TEXT_ROUTE_ITEM_3 = 'text-route-item-3',
  TEXT_ROUTE_ITEM_4 = 'text-route-item-4',
  TEXT_ROUTE_ITEM_5 = 'text-route-item-5',
  TEXT_START_ITEM_1 = 'text-start-item-1',
  TEXT_START_ITEM_2 = 'text-start-item-2',
  TEXT_START_ITEM_3 = 'text-start-item-3',
  TEXT_START_ITEM_4 = 'text-start-item-4',
  TEXT_START_ITEM_5 = 'text-start-item-5',
  TEXT_TOTAL_INFUSION_DURATION = 'text-total-infusion-duration',
  TEXT_TRANSFUSION_MODALITY = 'text-transfusion-modality',
  TEXT_TYPE = 'text-type',
  TEXT_UNIT_INFUSION_DURATION = 'text-unit-infusion-duration',
  TEXT_UNIT_OF_MEASUREMENT = 'text-unit-of-measurement',
  TEXT_UNIT_OF_MEASUREMENT_ITEM_1 = 'text-unit-of-measurement-item-1',
  TEXT_UNIT_OF_MEASUREMENT_ITEM_2 = 'text-unit-of-measurement-item-2',
  TEXT_UNIT_OF_MEASUREMENT_ITEM_3 = 'text-unit-of-measurement-item-3',
  TEXT_UNIT_OF_MEASUREMENT_ITEM_4 = 'text-unit-of-measurement-item-4',
  TEXT_UNIT_OF_MEASUREMENT_ITEM_5 = 'text-unit-of-measurement-item-5',
  TEXT_VOLUME_ML = 'text-volume-ml',
  TEXT_VOLUME_TO_BE_REMOVED = 'text-volume-to-be-removed',
}
export { BloodProductsViewFragmentAliases };
